import React from 'react';

import CourseHeading from '../../BookLandingPageComp/landingPage/heading/CourseHeading';

interface BookDescriptionProps {
  skills: string[];
}

const CourseSkillsSection: React.FC<BookDescriptionProps> = ({ skills }) => {
  return (
    <div className='w-full'>
      <CourseHeading heading='Skills you will gain' />
      <div className='flex gap-2 flex-wrap w-full items-center'>
        {skills.map((skill, index) => (
          <div key={`${skill}-${index}`}>
            <div className='px-4 py-1.5 text-sm border border-[#504F53] rounded-[5px] text-white bg-black'>
              {skill}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseSkillsSection;
